export default __webpack_public_path__ + "media/projects/blue1-bb5861ac.svg";